import {Injectable} from '@angular/core';
import {ShareholderDTO} from '@dto/entities/shareholder-dto.model';
import {ShareholdersViewModel} from './shareholders-view.model';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';

@Injectable({
  providedIn: 'root'
})
export class ShareholdersConverterService {

  convert(clients: ShareholderDTO[]): ShareholdersViewModel[] {
    return clients.map(c => this.convertSingle(c));
  }

  private convertSingle(shareHolder: ShareholderDTO): ShareholdersViewModel {

    if (!(shareHolder.Name)) {
      shareHolder.Name = 'No name available';
    }

    if (!(shareHolder.TotalShares)) {
      shareHolder.TotalShares = '0';
    }

    if (!(shareHolder.TotalValue)) {
      shareHolder.TotalValue = '0';
    }

    return {
      name: shareHolder.Name,
      totalShares: new FormattedNumber(shareHolder.TotalShares),
      totalValue: new FormattedNumber(shareHolder.TotalValue),
    };
  }
}
